var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreeExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61743",
    "data-name": "Group 61743",
    transform: "translate(13098 -9344)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39979",
    "data-name": "Ellipse 39979",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(-13098 9344)",
    fill: "#e3e6e7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61742",
    "data-name": "Group 61742",
    transform: "translate(-13347 7757.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61733",
    "data-name": "Group 61733",
    transform: "translate(264.605 1595.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82357",
    "data-name": "Path 82357",
    d: "M284.836,1600.672a2.669,2.669,0,1,1,2.669-2.669A2.672,2.672,0,0,1,284.836,1600.672Zm0-4.13A1.461,1.461,0,1,0,286.3,1598,1.462,1.462,0,0,0,284.836,1596.542Z",
    transform: "translate(-282.167 -1595.333)",
    fill: "#afb4b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61734",
    "data-name": "Group 61734",
    transform: "translate(264.605 1608.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82358",
    "data-name": "Path 82358",
    d: "M284.836,1643.63a2.669,2.669,0,1,1,2.669-2.669A2.672,2.672,0,0,1,284.836,1643.63Zm0-4.13a1.461,1.461,0,1,0,1.46,1.46A1.462,1.462,0,0,0,284.836,1639.5Z",
    transform: "translate(-282.167 -1638.292)",
    fill: "#afb4b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61735",
    "data-name": "Group 61735",
    transform: "translate(266.669 1600.067)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22606",
    "data-name": "Rectangle 22606",
    width: 1.209,
    height: 8.851,
    transform: "translate(0 0)",
    fill: "#afb4b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61738",
    "data-name": "Group 61738",
    transform: "translate(267.274 1601.931)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61736",
    "data-name": "Group 61736",
    transform: "translate(4.826 4.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82359",
    "data-name": "Path 82359",
    d: "M309.64,1638.455a2.669,2.669,0,1,1,2.669-2.669A2.672,2.672,0,0,1,309.64,1638.455Zm0-4.13a1.461,1.461,0,1,0,1.46,1.461A1.463,1.463,0,0,0,309.64,1634.326Z",
    transform: "translate(-306.971 -1633.117)",
    fill: "#afb4b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61737",
    "data-name": "Group 61737",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82360",
    "data-name": "Path 82360",
    d: "M299.1,1622.591h-1.209v-2.507a1.71,1.71,0,0,0-1.708-1.708H291v-1.209h5.183a2.92,2.92,0,0,1,2.917,2.917Z",
    transform: "translate(-291 -1617.167)",
    fill: "#afb4b7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_61741",
    "data-name": "Group 61741",
    transform: "translate(257 1601.931)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61739",
    "data-name": "Group 61739",
    transform: "translate(0 4.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82361",
    "data-name": "Path 82361",
    d: "M259.669,1638.455a2.669,2.669,0,1,1,2.669-2.669A2.672,2.672,0,0,1,259.669,1638.455Zm0-4.13a1.461,1.461,0,1,0,1.461,1.461A1.462,1.462,0,0,0,259.669,1634.326Z",
    transform: "translate(-257 -1633.117)",
    fill: "#afb4b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61740",
    "data-name": "Group 61740",
    transform: "translate(2.065 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82362",
    "data-name": "Path 82362",
    d: "M265.042,1622.591h-1.209v-2.507a2.92,2.92,0,0,1,2.917-2.917h5.183v1.209H266.75a1.71,1.71,0,0,0-1.708,1.708Z",
    transform: "translate(-263.833 -1617.167)",
    fill: "#afb4b7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeExpand);
export default __webpack_public_path__ + "static/media/tree-expand.371e69039ef03a3395ecf985ca49cc2d.svg";
export { ForwardRef as ReactComponent };